import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { ContentEngagementSummary, TimeRangeKey } from "@colab/shared";

export function useContentEngagement(range: TimeRangeKey) {
  return useQuery<ContentEngagementSummary, ApiClientError>({
    queryKey: queryKeys.portal.analytics.contentEngagement(range),
    queryFn: () =>
      apiFetch<ContentEngagementSummary>(
        `/portal/analytics/content-engagement?range=${range}`,
      ),
  });
}
